import { Button, SvgIconProps, Tooltip, useTheme } from '@mui/material'
import React, { ComponentType } from 'react'

import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

interface IconButtonProps {
  icon: ComponentType<SvgIconProps>
  tooltip?: string
  isDisabled?: boolean
  onClick?: () => void
  isWarning?: boolean
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    backgroundColor: 'transparent',
    color: theme.palette.text.primary,
    padding: 4,
    margin: 0,
    transition: 'All 300ms ease',
    overflow: 'hidden !important',
    minWidth: '0 !important',

    '&:hover': {
      backgroundColor: '#EAE9FC',
    },

    '&:disabled': {
      backgroundColor: 'transparent',
    },
  },
}))

const IconButton: React.FC<IconButtonProps> = ({
  icon: Icon,
  onClick,
  isDisabled = false,
  tooltip = '',
  isWarning = false,
}) => {
  const classes = useStyles()
  const theme = useTheme()

  const handleClick = () => {
    if (!isDisabled) {
      onClick!()
    }
  }

  let color = isDisabled ? 'disabled' : 'primary'

  if (isWarning) {
    color = 'error'
  }

  return (
    <Tooltip title={isDisabled ? '' : tooltip}>
      <Button
        type='button'
        variant='text'
        size='small'
        onClick={handleClick}
        disabled={isDisabled}
        className={classes.root}
      >
        <Icon
          fontSize='medium'
          color={color as any}
        />
      </Button>
    </Tooltip>
  )
}

export default IconButton
